import React, {  useState, useEffect, useRef} from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {aPIURL} from '../utils/common';
import { useReactToPrint } from 'react-to-print';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const OutStandingReport = () => 
{           
            const [cName,setCName]=useState();
            const [rptDate,setRptDate]=useState();
            const [totalCR,setTotalCR]=useState(0);
            const [totalDR,setTotalDR]=useState(0);
            const [closingBalance,setClosingBalance]=useState(0);
            const [customerData, setCustomerData]= useState([]);   
            const [finyearData, setFinyearData]= useState([]); 
            const fileType ="xlsx";
            const tableRef = useRef(null);
            const API_URL=aPIURL();
            const [custID,setCustID] = useState('0');     
            const [finyearID,setFinyearID] = useState('0'); 
            const [paymentStatusID,setPaymentStatusID] = useState('0');       
            const [post, setPost] = useState([]);
            const [sdate,setSdate] = useState();
            const [edate,setEdate] = useState();            
            const [fnCheck,setFnCheck] = useState(false);

            useEffect(() => {

                //customer list
                const curls=API_URL+`GpsSaleCustomerList/`;    
                axios.post(curls).then(response => {        
                setCustomerData(response.data.data);                       
                }).catch(function(error) { console.log(error.message); });  

                //financial year    
                const finurls=API_URL+`finyear/`;    
                axios.post(finurls).then(response => {        
                setFinyearData(response.data.data); 
                console.log("financial year");
                console.log(response.data.data);                      
                }).catch(function(error) { console.log(error.message); });                   
                SetDates();                
            }, []);
              
const SetDates=()=>{
              //set today date as default date starts
                var now = new Date();
                var month = (now.getMonth() + 1);               
                var day = now.getDate();
                if (month < 10) 
                month = "0" + month;
                if (day < 10) 
                day = "0" + day;
                var today = day + '-' + month + '-' + now.getFullYear();
                var endDate = now.getFullYear() + '-' + month + '-' + day;
                setRptDate(today);
                setSdate("2024-01-01");     
                setEdate(endDate);   

}             
const FillGrid=()=>
{
    const curls=API_URL+`GetOutstandingReport/0/0/0/0/0`;  
    setPost([]);
    axios.get(curls).then(response => {          
    setPost(response.data.data);
    setCName(response.data.data[0].customerName);
    setClosingBalance(response.data.data[0].tcBalance);
    setTotalCR(response.data.data[0].tcr);
    setTotalDR(response.data.data[0].tdr);
    //set today date as default date starts
    var now = new Date();
    var month = (now.getMonth() + 1);               
    var day = now.getDate();
    if (month < 10) 
    month = "0" + month;
    if (day < 10) 
    day = "0" + day;
    var today = day + '-' + month + '-' + now.getFullYear();
    setRptDate(today);
    
     }).catch(function(error){console.log(error.message);});
}
const Filter_Grid=()=>
{
    const curls=API_URL+`GetOutstandingReport/${finyearID}/${custID}/${paymentStatusID}/${sdate}/${edate}`;  
    setPost([]);
    axios.get(curls).then(response => {             
    setPost(response.data.data);
    setCName(response.data.data[0].customerName);
    setClosingBalance(response.data.data[0].tcBalance);
    setTotalCR(response.data.data[0].tcr);
    setTotalDR(response.data.data[0].tdr);    
    
     }).catch(function(error){console.log(error.message);});
}
const FilterGrid=()=>
{
       Filter_Grid();              
}

const ChangeCustomerID = (e) => {

        setCustID(e.target.value);                      
}
const ChangeDDLFinyear=(e)=>{

      setTotalCR(0);
      setTotalDR(0);
      setClosingBalance(0);
      setFinyearID(e.target.value);
      let fYearID = e.target.value;
      console.log(finyearData);
      if(parseInt(fYearID)>0)
      {
          setFnCheck(true);
          const updatedFinyearData = finyearData.filter((curElem1) => {  return curElem1.id === parseInt(fYearID);   });
          let startDate = updatedFinyearData[0].fStDate;
          let endDate = updatedFinyearData[0].fEndDate;          
          setSdate(startDate);
          setEdate(endDate);
      }
      else
      {
           setFinyearID(0);
           SetDates();            
           setFnCheck(false);           
      }
}
const ChangeDDLPaymentStatusID=(e)=>{
     setPaymentStatusID(e.target.value);    
}
const exportStatus = e => {
          
    FillGrid();
}
const exportToCSV=()=>
{
       const newPost = post.map(({ tcBalance,tcr,tdr,rDate,reference,voucherNo , ...rest }) => rest);
       const ws= XLSX.utils.json_to_sheet(newPost);        
       var wscols = [
          {wch:10},
          {wch:20},
          {wch:20},
          {wch:20},
          {wch:20}
      ];
   
      var wsrows = [
         {hpx: 30}
      ];
      
      ws['!cols'] = wscols;
      ws['!rows']=wsrows;
           
      let Heading = [['S.NO.','NAME','DR','CR','CLOSING BALANCE']];
      const wb={Sheets:{OutStanding:ws},SheetNames:["OutStanding"]};
      XLSX.utils.sheet_add_aoa(ws, Heading);     
      const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
      const data= new Blob([excelBuffer],{type:fileType});
      FileSaver.saveAs(data,"AVTOutstanding"+".xlsx");
     }

const ResetList=()=>
{
      setPost([]);      
      setTotalCR(0);
      setTotalDR(0);
      setClosingBalance(0);
      setCName('');
      setCustID(0);   
      setFnCheck(false);
      setFinyearID(0);
      setPaymentStatusID(0);
      SetDates();
      FillGrid();
      
}
const SDatechangeHandler = (e) => 
{   
    setSdate(e.target.value);    
} 
const EDatechangeHandler = (e) => 
{   
    setEdate(e.target.value)
}
const exportDownload = e => 
{  
  
  const value = e.target.value;   
  if(value==="Excel")
  {
        exportToCSV();   
  }
  if(value==="PDF")
  {
        handlePrint(null, () => tableRef.current);
  }
}

const handlePrint = useReactToPrint({
  documentTitle: "Outstanding",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});

  return (
  <>   
  <div className="top-bar clearfix">
  <div className="row">
  <div className="col-md-4">
  <h2> OutStanding Report </h2>           
  </div>
  <div className="col-md-8 text-right">                    
    <select onChange={exportDownload} className="btn btn-primary" name="Download" >
    <option value={"Download"}>Download</option>    
    <option value={"Excel"}>Excel</option>    
    <option value={"PDF"}>PDF</option>                      
    </select>
    </div></div></div>    
    <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div class="card-body">
    <div class="row">       
    <div class="col-sm-2 col-lg-2" style={{textAlign:"right"}}>
    Customer Name
    </div>  
    <div class="col-sm-4 col-lg-3">   
    <select className="form-control"  name="DCustomerID" value={custID} onChange={ChangeCustomerID} >
    <option value={0}>------ All Customer ------</option>
    {customerData.map((e, key) => {
    return <option key={key} value={e.accountID}>{e.customerName}</option>;
    })}
   </select></div>  
   <div class="col-sm-4 col-lg-2" style={{textAlign:"right"}}>
   Payment Status
   </div>  
    <div class="col-sm-4 col-lg-2">   
    <select className="form-control"  name="DDLPaymentStatusID" value={paymentStatusID} onChange={ChangeDDLPaymentStatusID} >
    <option value={0}>------ All ------</option>
    <option value={1}>Paid</option>
    <option value={2}>Pending</option>
    </select></div>   
    <div class="col-sm-4 col-lg-2">
    <button type="button" class="btn btn-primary2 mt-20" tabindex="3" id="btnSearchNew" onClick={FilterGrid} >Search</button>
    <button type="button" class="btn btn-secondary mt-20" id="btnResetNew" tabindex="4" onClick={ResetList}>Reset
    </button></div>  
    </div></div></div>
  <div className="container-fluid p-3">
    <div class="card mb-3 shadow no-border border-0">
    <div ref={tableRef} style={{ padding:"25px"}} class="card-body">    
    <div class="row align-items-end">  
    <span style={{ textAlign:'center',fontSize:"18px" }}><b>OutStanding Report</b> </span>
    <span style={{ textAlign:'right' }}>DATE : { rptDate }</span>    
    <table  id="example" class="table table-striped table-bordered table-hover" style={{width:"100%", marginTop:"25px"}}>
    <thead>
    <tr>
    <th style={{ width:"5%", textAlign:"center"}}>S.No.</th>
    <th style={{width:"35%",textAlign:"center","cursor": "pointer"}}>CUSTOMER NAME </th>
    <th style={{width:"20%",textAlign:"center","cursor": "pointer"}}>DR </th>
    <th style={{width:"20%",textAlign:"center","cursor": "pointer"}}>CR </th>
    <th style={{width:"20%",textAlign:"center","cursor": "pointer"}}>OutStanding Amount </th>   
    </tr>
    </thead>
    <tbody>
    {post.map((devdata) => {
                return (
                <tr key={devdata.id}>
                  <td style={{textAlign:"center"}}>{devdata.id}</td>
                  <td style={{textAlign:"left"}}>{devdata.customerName}</td>
                  <td style={{textAlign:"right"}}>{devdata.dr}</td>
                  <td style={{textAlign:"right"}}>{devdata.cr}</td>
                  <td style={{textAlign:"right"}}>{devdata.closingBalance}</td>                             
                </tr>
               );
            })}
      </tbody>
    </table>
    <span style={{ textAlign:'right' }}><b> Total DR : &nbsp;{ totalDR }</b></span> 
    <span style={{ textAlign:'right' }}><b> Total CR : &nbsp;{ totalCR }</b></span> 
    <span style={{ textAlign:'right' }}><b> Total OutStanding : &nbsp;{ closingBalance }</b></span> 
    </div></div></div></div></div>
    <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>       
    </>
    ); }   
export default OutStandingReport;
